import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useBrand } from '@aviv-unified-frontend/runtime/brand';
import { useLocale } from '@aviv-unified-frontend/runtime/i18n';
import { initializeGatewayModule } from '@price-pages-agency-cards/src/infrastructure/gateway/agency.module';
import { logger } from '@price-pages-agency-cards/src/infrastructure/logger';
import { Brand } from '@shared-utils/domain/brand.entity';
import { EventChannel, EventPortal, EventProduct } from '@shared-utils/domain/event.entity';
import { initStatsEventService } from '@shared-utils/helpers/statsEvent';
import { useBreakpoint } from '@shared-utils/helpers/viewport';
import { initializeStore, useAgencyStore } from '../hooks/useAgencyHook';
const gateway = initializeGatewayModule();
initializeStore(gateway);
export const DataProvider = ({ agencyId, agencyIds, postalCode, children }) => {
    const { language } = useLocale();
    const { id } = useBrand();
    const brand = new Brand(id).getEnumValue();
    const { isMobile } = useBreakpoint();
    const fetchAgencyById = useAgencyStore((state) => state.fetchAgencyById);
    const fetchAgenciesByIds = useAgencyStore((state) => state.fetchAgenciesByIds);
    const fetchRecommendedAgencies = useAgencyStore((state) => state.fetchRecommendedAgencies);
    const setLastZipCode = useAgencyStore((state) => state.setLastZipCode);
    useEffect(() => {
        initStatsEventService({
            channel: isMobile ? EventChannel.WEB_MOBILE : EventChannel.WEB_DESKTOP,
            portal: EventPortal[brand],
            product: EventProduct.INTERMEDIARY_CARD,
        }, logger.error);
    }, []);
    useEffect(() => {
        if (agencyId) {
            fetchAgencyById({ brand, id: agencyId, locale: language });
        }
    }, [agencyId, brand, language, fetchAgencyById]);
    useEffect(() => {
        if (agencyIds?.length) {
            fetchAgenciesByIds({ brand, ids: agencyIds, locale: language });
        }
    }, [agencyIds, brand, fetchAgenciesByIds, language]);
    useEffect(() => {
        if (postalCode) {
            fetchRecommendedAgencies({ brand, postalCode });
            setLastZipCode(postalCode);
        }
    }, [postalCode, brand, fetchRecommendedAgencies, setLastZipCode]);
    const hasValidProps = Boolean(agencyId || postalCode || (agencyIds && agencyIds.length > 0));
    if (!hasValidProps) {
        logger.warn('DataProvider: No valid query parameters provided (agencyId, postalCode, or agencyIds)');
    }
    return _jsx(_Fragment, { children: children });
};
